import React from "react";
import Dashboard from "../../common/Dashboard";
import DashboardConfig from "../system-admin/Dashboard/DashboardConfig";

export default function AuditAdminDashboard() {
  return (
    <Dashboard sidebarType="Audit Admin">
      <DashboardConfig />
    </Dashboard>
  );
}
